/**
 * Get the amount of days between two dates, including the start and end day.
 * @returns
 */
export function getAmountOfDaysIncludingStartEnd(from: string, to: string): number {
  const startDate = new Date(from);
  const endDate = new Date(to);

  // remove the time part so both time is 00:00:00
  const start = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  const end = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

  const diff = Math.abs(end.getTime() - start.getTime());
  // add one to include the end day
  return Math.ceil(diff / (1000 * 60 * 60 * 24)) + 1;
}
